<div class="page-layout">
  @if (displayHeader) {
    <div class="header">
      <h2>{{ 'activities.title' | translate }}</h2>
    </div>
  }
  <content class="content inner-scroll">
    <router-outlet></router-outlet>
  </content>
</div>

